export default function hasOnlyActiveOptionsProp() {
    return {
        onlyActiveOptions: {
            type: Boolean,
            default: false,
        },
    };
}
